import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { createEmploymentStatusQuery } from 'components/SearchSideBar/logics/createQuery/employmentStatus';
import { FeaturedSearchConditionQuery } from 'components/SearchSideBar/types';

interface ArgumentType {
  savedSearchCondition?: SavedSearchResponse | undefined;
  featuredSearchCondition?: FeaturedSearchConditionQuery | undefined;
  queries: string[] | undefined;
}

/**
 * クエリ、保存した検索条件、特集枠検索条件からどのidを返すか処理する
 * @param param.savedSearchCondition 保存した検索条件
 * @param param.featuredSearchCondition 特集枠検索条件
 * @param param.queries クエリ
 * @returns idの配列
 */
export const getInitialIdList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition) {
    const idList = savedSearchCondition.employmentStatusList
      ? createEmploymentStatusQuery(savedSearchCondition.employmentStatusList)
      : [];

    return idList;
  }

  // 特集枠検索条件
  if (featuredSearchCondition) {
    const idList = featuredSearchCondition.employmentStatus
      ? createEmploymentStatusQuery(featuredSearchCondition.employmentStatus)
      : [];
    return idList;
  }

  // クエリから取得した検索条件
  return queries;
};
